import { ChangeEvent, FC, useCallback } from 'react';
import styled from 'styled-components';

import type { ColumnProps } from './model';

interface CheckBoxColumnProps extends ColumnProps<boolean> {}

const StyledInput = styled.input`
  width: 1.25rem;
  height: 1.25rem;
`;

export const GridCheckBoxColumn: FC<CheckBoxColumnProps> = ({ value, id, setCellValue }) => {
  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setCellValue(id, e.target.checked);
    },
    [id, setCellValue],
  );

  return (
    <div className="d-flex justify-content-center">
      <StyledInput
        className="form-check-input ms-0"
        checked={value}
        disabled={false}
        id={id}
        name={id}
        onChange={onChange}
        type="checkbox"
      />
    </div>
  );
};
